import React from 'react';
import { Field } from 'react-final-form';
import css from './FieldChipsGroup.module.css';
import { NamedLink } from '../../components';
import { FormattedMessage } from '../../util/reactIntl';


const FieldChipsGroup = props => {
    const { id, name, label, options, validate, addShopButton, addBrandButton, displayColumn } = props;

    const FieldChipsGroupComponent = ({ input: { onChange, value }, ...rest }) => {
        return (
            <div className={displayColumn ? css.rootColumn : css.root}>
                <label className={css.fieldLabel}>{label}</label>
                <div className={css.chipsContainer} >
                    {options && options.map((option, index) => {
                        return (
                            <div
                                className={value === option.key ? css.chipSelected : css.chip}
                                key={option.key}
                                onClick={e => {
                                    onChange(option.key);
                                }}
                            >
                                <p className={css.chipLabel}>
                                    {option.label}
                                </p>
                            </div>
                        );
                    })}
                    {addShopButton &&
                        <NamedLink
                            className={css.chip}
                            name="NewStorePage"
                        >
                            <p className={css.chipLabel}>
                                <FormattedMessage id="TopbarDesktop.addNewStore" />
                            </p>
                        </NamedLink>
                    }
                    {addBrandButton &&
                        <NamedLink
                            className={css.chip}
                            name="NewBrandPage"
                        >
                            <p className={css.chipLabel}>
                                <FormattedMessage id="TopbarDesktop.addNewBrand" />
                            </p>
                        </NamedLink>
                    }
                </div>
            </div>
        );
    };

    return (
        <Field id={id} name={name} component={FieldChipsGroupComponent} validate={validate} />
    );
};

export default FieldChipsGroup;
